class NBDMeasurements extends HTMLElement {
  constructor() {
    super();
    this.handleToggle = this.handleToggle.bind(this);
  }

  connectedCallback() {
    this.toggle = this.querySelector('.nbd-measurements-switch input');
    this.cells = this.querySelectorAll('.nbd-measurements-table td[data-cm]');
    this.toggle?.addEventListener('change', this.handleToggle);
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('change', this.handleToggle);
  }

  handleToggle(event) {
    this.cells.forEach((cell) => {
      const cm = cell.dataset.cm;
      cell.textContent = event.target.checked ? this.toInches(cm) : cm;
    });
  }

  // Rounds to the nearest half inch.
  toInches(value) {
    const cm = Number(value);
    if (value === '' || isNaN(cm)) return value;
    return String(Math.round(cm * 0.3937008 * 2) / 2).replace('.5', ' ½');
  }
}

if (!customElements.get('nbd-measurements')) {
  customElements.define('nbd-measurements', NBDMeasurements);
}
